'use client';

import { useSyncExternalStore } from 'react';
import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { getCookieConsent, subscribe } from '@/lib/cookie-consent';
import { TrackingScripts } from './TrackingScripts';

type GoogleTrackingMode = 'none' | 'ga4' | 'gtm';

interface ConsentGatedTrackingProps {
  googleTrackingMode?: GoogleTrackingMode | null;
  googleAnalyticsId: string | null;
  googleTagManagerId: string | null;
  googleTagManagerEnabled: boolean;
}

function useHasConsent(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => getCookieConsent() === 'accepted',
    () => false,
  );
}

export function ConsentGatedTracking(props: ConsentGatedTrackingProps) {
  const accepted = useHasConsent();

  if (!accepted) return null;

  return (
    <>
      <TrackingScripts {...props} />
      <Analytics />
      <SpeedInsights />
    </>
  );
}
